<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="lista_solicitud_por_aprobar")
        .contenedor-interno
          .title
            span Mis documentos para firmar
          transition(name="fade")
            .position-relative(
              key="list-solicitudes"
            )
              transition(name='fade-quick')
                .modal.is-active(
                  v-if="mostrarModalAdjuntar"
                  :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
                )
                  .modal-background
                  upload-image(
                    name="adjuntar_documento_importante",
                    onlyPdf="true",
                    folder="documentos_firmar_empleado",
                    @save="guardarDocumentoSubido"
                    @close="closeModalAdjuntar"
                  )
                    span(slot="title") Adjunte un PDF
                    span(slot="explanation")
                      strong Se agregará el sello de firma digital cuando se suba el archivo.
                    i.fa.fa-file-pdf-o(slot="topIcon")
              transition(name='fade')
                .modal.is-active(
                  v-if="mostrarConfirmacionEliminar"
                )
                  .modal-background
                  confirmar-accion-overlay(
                    @close="closeModalEliminar()"
                    @do="eliminarDocumento()"
                    :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
                    ref="confirmarEliminar"
                  )
                    span(slot="title") ¿Desea eliminar el pdf subido?
                    span(slot="primaryAction")
                      template(v-if="isSending")
                        | Eliminando...
                      template(v-else)
                        | Eliminar
              transition(name='fade')
                .modal.is-active(
                  v-if="mostrarConfirmacionEliminar"
                )
                  .modal-background
                  confirmar-accion-overlay(
                    @close="closeModalEliminar()"
                    @do="eliminarDocumento()"
                    :class="{'modal-sidebar-desktop-open': showSidebarDesktop }"
                    ref="confirmarEliminar"
                  )
                    span(slot="title") ¿Desea eliminar el pdf subido?
                    span(slot="primaryAction")
                      template(v-if="isSending")
                        | Eliminando...
                      template(v-else)
                        | Eliminar
              .message.is-warning
                .message-body Al subir el pdf se agregará el sello de firma
              .text-right.acciones
                button.button.is-small.mb-5(@click="fetch")
                  span.icon.is-small
                    i.fa.fa-refresh
                  span Refrescar
              div
                loading(v-if="isLoading")
                table.table.is-striped.is-bordered(v-if="!isLoading && lista.length > 0")
                  thead
                    th Descripcion
                    th Acciones
                  tbody(
                    name="table-row"
                    is="transition-group"
                  )
                    tr.row-table(
                      v-for="(o, index) in lista"
                      :key="index"
                    )
                      td
                        .hint--top(:aria-label="'ID: ' + o.id")
                          span {{ o.descripcion }}
                          .seen.name.fs-12(v-if="o.revisado")
                            span.has-text-bold Aprobado por RRHH
                      td.text-center
                        .contenedor-acciones
                          button.button.is-small.is-primary(:class="{'is-loading':downloading}" :disabled="downloading" v-if="!o.rutaSubido && !o.revisado" @click="descargarDocumento(o)")
                            span.icon.is-small
                              i.fa.fa-download.is-small.fs-12
                            span Descargar documento
                          button.button.is-small(v-if="!o.rutaSubido && !o.revisado", @click="confirmacionSubirPdf(o)" :disabled="!o.fechaDescarga")
                            span.icon.is-small
                              i.fa.fa-file-pdf-o
                            span Subir y firmar PDF
                          a.button.is-small(v-if="o.rutaSubido" :href="o.rutaSubido" target="_blank")
                            span.icon.is-small
                              i.fa.fa-eye.is-small.fs-12
                            span Ver PDF
                          button.button.is-small.is-danger(v-if="o.rutaSubido && !o.revisado", @click="confirmacionEliminarPdf(o)")
                            span.icon.is-small
                              i.fa.fa-times
                            span Eliminar
                .info-message(v-if="!isLoading && lista.length === 0")
                  span No se encontraron documentos por firmar
</template>

<script>
import { apiDelete, apiGet, apiPost, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
import ComponentUploadImage from '../components/Component_Upload_Image'
export default {
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    'upload-image':ComponentUploadImage
  },
  data () {
    return {
      lista: [],
      isLoading: false,
      mostrarConfirmacionEliminar: false,
      isSending: false,
      codigoEmpleado: +localStorage.getItem('codigo'),
      mostrarModalAdjuntar: false,
      documento:{},
      downloading:false
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    fetch () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        codigoEmpleado: vm.codigoEmpleado
      }
      apiGet(vm, '/documentos-firmar/mis-documentos', obj, function (data) {
        if (data.status === 1) {
          vm.lista = data.lista
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    confirmacionSubirPdf (row) {
      this.documento = row
      this.mostrarModalAdjuntar = true
    },
    confirmacionEliminarPdf (row) {
      this.documento = row
      this.mostrarConfirmacionEliminar = true
    },
    guardarDocumentoSubido (fileSubido) {
      var vm = this
      var obj = {
        id: vm.documento.id,
        codigoEmpleado: vm.documento.codigoEmpleado,
        ruta:fileSubido.file.ruta
      }
      apiPost(vm, '/documentos-firmar/subir-pdf', obj, function (data) {
        if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
          vm.fetch()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.closeModalAdjuntar()
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    eliminarDocumento () {
      var vm = this
      var obj = {
        id: vm.documento.id
      }
      apiDelete(vm, '/documentos-firmar/mi-pdf', obj, function (data) {
        if (data.status === 1) {
          notify(vm, 'success', 'Éxito', data.message)
          vm.fetch()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.closeModalEliminar()
        apiGet(vm, '/documentos-firmar/sin-cargar', {}, function (data) {
          vm.$store.dispatch('setDocumentosPorFirmar', data.lista.length)
        })
      })
    },
    closeModalEliminar () {
      this.mostrarConfirmacionEliminar = false
      this.documento = null
    },
    closeModalAdjuntar () {
      this.mostrarModalAdjuntar = false
      this.documento = null
    },
    descargarDocumento (row) {
      var vm = this
      if (vm.downloading) return
      vm.downloading = true

      var obj = { id:row.idDetalle }
      apiGet(vm, '/documentos-firmar/mis-documentos/descargar', obj, function (data) {
        if (data.status === 1) {
          vm.fetch()
          window
          .open(data.ruta, '_blank')
          .focus()
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.downloading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    display: flex
    justify-content: center;
    align-items: flex-end;
    .acciones
      display flex
      justify-content space-around
      .button
        flex 1
        margin 0px 5px
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      cursor pointer
      i
        font-size 16px

    .title
      padding-left: 10px
      padding-right: 10px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  .contenedor-acciones
    padding-top 4px
    display flex
    justify-content space-around
    flex-wrap wrap
    .button
      flex 1
      margin 0px 5px
      // i
      //   margin-left 2px
      //   font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  th
    text-align center

  td
    vertical-align: middle;

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px


  .dias-pedidos
    font-size 12px
    color #9a9a9a

  .fs-12
    font-size 12px

  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width 578px)
    .is-mobile
      display block

    .is-desktop
      display none
  @media (max-width 515px)
    .contenedor-acciones
      .button
        margin-top: 4px
        margin-bottom:4px

</style>



// WEBPACK FOOTER //
// View_Mis_Documentos_Firmar.vue?28774273